export const COMMUNICATION_EVENT_GROUPS = [
  {
    key:'admission', label:'Admissions', icon:'🎓', events:[
      ['admission.submitted','Application Submitted','Applicant/parent receives acknowledgement after a successful application.'],
      ['admission.approved','Admission Approved','Sent when staff approves an application.'],
      ['admission.enrolled','Enrollment Completed','Sent after the student record and fee ledger are created.'],
    ],
  },
  {
    key:'fees', label:'Fees & Payments', icon:'🧾', events:[
      ['fee.paid','Fee Payment Received','Receipt/payment confirmation after a verified fee transaction.'],
      ['fee.partial','Partial Payment Received','Confirmation when part of an installment or fee head is paid.'],
      ['fee.due','Fee Due Reminder','Upcoming due reminder according to the institute reminder policy.'],
      ['fee.overdue','Fee Overdue','Overdue reminder and optional access-lock information.'],
    ],
  },
  {
    key:'attendance', label:'Attendance & Movement', icon:'✅', events:[
      ['attendance.in','Student IN','Parent/student notification when the student enters the institute.'],
      ['attendance.out','Student OUT','Parent/student notification when the student leaves the institute.'],
      ['attendance.absent','Student Absent','Absence notification after attendance is finalized.'],
      ['attendance.fee_due','Attendance Fee Reminder','Coaching attendance reminder when fee is overdue; cooldown applies.'],
    ],
  },
  {
    key:'academics', label:'Academics', icon:'📚', events:[
      ['assignment.published','Assignment Published','Students receive the assignment title, due date and app link.'],
      ['homework.published','Homework Published','Students receive homework details and due date.'],
      ['lessonplan.returned','Lesson Plan Returned','Teacher receives coordinator review notes.'],
      ['lessonplan.approved','Lesson Plan Approved','Teacher receives approval confirmation.'],
    ],
  },
  {
    key:'exams', label:'Examinations', icon:'📝', events:[
      ['exam.schedule.published','Exam Schedule Published','Students receive examination timetable availability.'],
      ['exam.admitcard.available','Admit Card Available','Students receive admit/hall-ticket availability.'],
      ['result.published','Result Published','Students/parents receive result availability.'],
      ['marksheet.available','Mark Sheet Available','Students receive mark-sheet availability.'],
    ],
  },
  {
    key:'general', label:'Institute Communication', icon:'🔔', events:[
      ['holiday.published','Holiday Announced','Students/parents receive holiday information.'],
      ['certificate.issued','Certificate Issued','Student receives certificate availability.'],
      ['digitalcourse.purchased','Digital Course Purchased','Purchase/access confirmation for a standalone digital course.'],
      ['digitalcourse.completed','Digital Course Completed','Completion and certificate eligibility notification.'],
    ],
  },
];

export const ALL_COMMUNICATION_EVENTS = COMMUNICATION_EVENT_GROUPS.flatMap(group =>
  group.events.map(([key,label,description]) => ({key,label,description,group:group.label,groupKey:group.key,icon:group.icon}))
);

export const DEFAULT_EVENT_CHANNELS = {
  email:true,
  sms:false,
  whatsapp:false,
  inApp:true,
  secureMessaging:false,
  parent:true,
  student:true,
};
